import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableRenters from "./components/table-renters/TableRenters";


function RenterRegisterPage() {
    return (
        <ToastProvider>
            <Dashboard>
                <TableRenters />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default RenterRegisterPage